export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14031.ac0ec7b4.jpg";